export const ADD_ALERT = "ADD_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const SHOW_PRIVACY_SETTINGS = "SHOW_PRIVACY_SETTINGS";
